<template>
  <v-select
    :append-icon="icon"
    box
    :disabled="disabled"
    hide-details
    :item-value="format"
    :items="countries"
    label="Country"
    :rules="rules"
    v-model="country"
  ></v-select>
</template>

<script>
export default {
  data: function () {
    return {
      countries: [
        {
          'text': 'Afghanistan',
          'alpha2': 'AF',
          'alpha3': 'AFG',
          'numeric': '004'
        },
        {
          'text': 'Albania',
          'alpha2': 'AL',
          'alpha3': 'ALB',
          'numeric': '008'
        },
        {
          'text': 'Algeria',
          'alpha2': 'DZ',
          'alpha3': 'DZA',
          'numeric': '012'
        },
        {
          'text': 'American Samoa',
          'alpha2': 'AS',
          'alpha3': 'ASM',
          'numeric': '016'
        },
        {
          'text': 'Andorra',
          'alpha2': 'AD',
          'alpha3': 'AND',
          'numeric': '020'
        },
        {
          'text': 'Angola',
          'alpha2': 'AO',
          'alpha3': 'AGO',
          'numeric': '024'
        },
        {
          'text': 'Anguilla',
          'alpha2': 'AI',
          'alpha3': 'AIA',
          'numeric': 660
        },
        {
          'text': 'Antarctica',
          'alpha2': 'AQ',
          'alpha3': 'ATA',
          'numeric': '010'
        },
        {
          'text': 'Antigua and Barbuda',
          'alpha2': 'AG',
          'alpha3': 'ATG',
          'numeric': '028'
        },
        {
          'text': 'Argentina',
          'alpha2': 'AR',
          'alpha3': 'ARG',
          'numeric': '032'
        },
        {
          'text': 'Armenia',
          'alpha2': 'AM',
          'alpha3': 'ARM',
          'numeric': '051'
        },
        {
          'text': 'Aruba',
          'alpha2': 'AW',
          'alpha3': 'ABW',
          'numeric': 533
        },
        {
          'text': 'Australia',
          'alpha2': 'AU',
          'alpha3': 'AUS',
          'numeric': '036'
        },
        {
          'text': 'Austria',
          'alpha2': 'AT',
          'alpha3': 'AUT',
          'numeric': '040'
        },
        {
          'text': 'Azerbaijan',
          'alpha2': 'AZ',
          'alpha3': 'AZE',
          'numeric': '031'
        },
        {
          'text': 'Bahamas',
          'alpha2': 'BS',
          'alpha3': 'BHS',
          'numeric': '044'
        },
        {
          'text': 'Bahrain',
          'alpha2': 'BH',
          'alpha3': 'BHR',
          'numeric': '048'
        },
        {
          'text': 'Bangladesh',
          'alpha2': 'BD',
          'alpha3': 'BGD',
          'numeric': '050'
        },
        {
          'text': 'Barbados',
          'alpha2': 'BB',
          'alpha3': 'BRB',
          'numeric': '052'
        },
        {
          'text': 'Belarus',
          'alpha2': 'BY',
          'alpha3': 'BLR',
          'numeric': 112
        },
        {
          'text': 'Belgium',
          'alpha2': 'BE',
          'alpha3': 'BEL',
          'numeric': '056'
        },
        {
          'text': 'Belize',
          'alpha2': 'BZ',
          'alpha3': 'BLZ',
          'numeric': '084'
        },
        {
          'text': 'Benin',
          'alpha2': 'BJ',
          'alpha3': 'BEN',
          'numeric': 204
        },
        {
          'text': 'Bermuda',
          'alpha2': 'BM',
          'alpha3': 'BMU',
          'numeric': '060'
        },
        {
          'text': 'Bhutan',
          'alpha2': 'BT',
          'alpha3': 'BTN',
          'numeric': '064'
        },
        {
          'text': 'Bolivia',
          'alpha2': 'BO',
          'alpha3': 'BOL',
          'numeric': '068'
        },
        {
          'text': 'Bonaire, Sint Eustatius and Saba',
          'alpha2': 'BQ',
          'alpha3': 'BES',
          'numeric': 535
        },
        {
          'text': 'Bosnia and Herzegovina',
          'alpha2': 'BA',
          'alpha3': 'BIH',
          'numeric': '070'
        },
        {
          'text': 'Botswana',
          'alpha2': 'BW',
          'alpha3': 'BWA',
          'numeric': '072'
        },
        {
          'text': 'Bouvet Island',
          'alpha2': 'BV',
          'alpha3': 'BVT',
          'numeric': '074'
        },
        {
          'text': 'Brazil',
          'alpha2': 'BR',
          'alpha3': 'BRA',
          'numeric': '076'
        },
        {
          'text': 'British Indian Ocean Territory',
          'alpha2': 'IO',
          'alpha3': 'IOT',
          'numeric': '086'
        },
        {
          'text': 'Brunei Darussalam',
          'alpha2': 'BN',
          'alpha3': 'BRN',
          'numeric': '096'
        },
        {
          'text': 'Bulgaria',
          'alpha2': 'BG',
          'alpha3': 'BGR',
          'numeric': 100
        },
        {
          'text': 'Burkina Faso',
          'alpha2': 'BF',
          'alpha3': 'BFA',
          'numeric': 854
        },
        {
          'text': 'Burundi',
          'alpha2': 'BI',
          'alpha3': 'BDI',
          'numeric': 108
        },
        {
          'text': 'Cabo Verde',
          'alpha2': 'CV',
          'alpha3': 'CPV',
          'numeric': 132
        },
        {
          'text': 'Cambodia',
          'alpha2': 'KH',
          'alpha3': 'KHM',
          'numeric': 116
        },
        {
          'text': 'Cameroon',
          'alpha2': 'CM',
          'alpha3': 'CMR',
          'numeric': 120
        },
        {
          'text': 'Canada',
          'alpha2': 'CA',
          'alpha3': 'CAN',
          'numeric': 124
        },
        {
          'text': 'Cayman Islands',
          'alpha2': 'KY',
          'alpha3': 'CYM',
          'numeric': 136
        },
        {
          'text': 'Central African Republic',
          'alpha2': 'CF',
          'alpha3': 'CAF',
          'numeric': 140
        },
        {
          'text': 'Chad',
          'alpha2': 'TD',
          'alpha3': 'TCD',
          'numeric': 148
        },
        {
          'text': 'Chile',
          'alpha2': 'CL',
          'alpha3': 'CHL',
          'numeric': 152
        },
        {
          'text': 'China',
          'alpha2': 'CN',
          'alpha3': 'CHN',
          'numeric': 156
        },
        {
          'text': 'Christmas Island',
          'alpha2': 'CX',
          'alpha3': 'CXR',
          'numeric': 162
        },
        {
          'text': 'Cocos (Keeling) Islands',
          'alpha2': 'CC',
          'alpha3': 'CCK',
          'numeric': 166
        },
        {
          'text': 'Colombia',
          'alpha2': 'CO',
          'alpha3': 'COL',
          'numeric': 170
        },
        {
          'text': 'Comoros',
          'alpha2': 'KM',
          'alpha3': 'COM',
          'numeric': 174
        },
        {
          'text': 'Congo (the Democratic Republic of the)',
          'alpha2': 'CD',
          'alpha3': 'COD',
          'numeric': 180
        },
        {
          'text': 'Congo',
          'alpha2': 'CG',
          'alpha3': 'COG',
          'numeric': 178
        },
        {
          'text': 'Cook Islands',
          'alpha2': 'CK',
          'alpha3': 'COK',
          'numeric': 184
        },
        {
          'text': 'Costa Rica',
          'alpha2': 'CR',
          'alpha3': 'CRI',
          'numeric': 188
        },
        {
          'text': 'Croatia',
          'alpha2': 'HR',
          'alpha3': 'HRV',
          'numeric': 191
        },
        {
          'text': 'Cuba',
          'alpha2': 'CU',
          'alpha3': 'CUB',
          'numeric': 192
        },
        {
          'text': 'Curaçao',
          'alpha2': 'CW',
          'alpha3': 'CUW',
          'numeric': 531
        },
        {
          'text': 'Cyprus',
          'alpha2': 'CY',
          'alpha3': 'CYP',
          'numeric': 196
        },
        {
          'text': 'Czechia',
          'alpha2': 'CZ',
          'alpha3': 'CZE',
          'numeric': 203
        },
        {
          'text': 'Côte d\'Ivoire',
          'alpha2': 'CI',
          'alpha3': 'CIV',
          'numeric': 384
        },
        {
          'text': 'Denmark',
          'alpha2': 'DK',
          'alpha3': 'DNK',
          'numeric': 208
        },
        {
          'text': 'Djibouti',
          'alpha2': 'DJ',
          'alpha3': 'DJI',
          'numeric': 262
        },
        {
          'text': 'Dominica',
          'alpha2': 'DM',
          'alpha3': 'DMA',
          'numeric': 212
        },
        {
          'text': 'Dominican Republic',
          'alpha2': 'DO',
          'alpha3': 'DOM',
          'numeric': 214
        },
        {
          'text': 'Ecuador',
          'alpha2': 'EC',
          'alpha3': 'ECU',
          'numeric': 218
        },
        {
          'text': 'Egypt',
          'alpha2': 'EG',
          'alpha3': 'EGY',
          'numeric': 818
        },
        {
          'text': 'El Salvador',
          'alpha2': 'SV',
          'alpha3': 'SLV',
          'numeric': 222
        },
        {
          'text': 'Equatorial Guinea',
          'alpha2': 'GQ',
          'alpha3': 'GNQ',
          'numeric': 226
        },
        {
          'text': 'Eritrea',
          'alpha2': 'ER',
          'alpha3': 'ERI',
          'numeric': 232
        },
        {
          'text': 'Estonia',
          'alpha2': 'EE',
          'alpha3': 'EST',
          'numeric': 233
        },
        {
          'text': 'Eswatini',
          'alpha2': 'SZ',
          'alpha3': 'SWZ',
          'numeric': 748
        },
        {
          'text': 'Ethiopia',
          'alpha2': 'ET',
          'alpha3': 'ETH',
          'numeric': 231
        },
        {
          'text': 'Falkland Islands [Malvinas]',
          'alpha2': 'FK',
          'alpha3': 'FLK',
          'numeric': 238
        },
        {
          'text': 'Faroe Islands',
          'alpha2': 'FO',
          'alpha3': 'FRO',
          'numeric': 234
        },
        {
          'text': 'Fiji',
          'alpha2': 'FJ',
          'alpha3': 'FJI',
          'numeric': 242
        },
        {
          'text': 'Finland',
          'alpha2': 'FI',
          'alpha3': 'FIN',
          'numeric': 246
        },
        {
          'text': 'France',
          'alpha2': 'FR',
          'alpha3': 'FRA',
          'numeric': 250
        },
        {
          'text': 'French Guiana',
          'alpha2': 'GF',
          'alpha3': 'GUF',
          'numeric': 254
        },
        {
          'text': 'French Polynesia',
          'alpha2': 'PF',
          'alpha3': 'PYF',
          'numeric': 258
        },
        {
          'text': 'French Southern Territories',
          'alpha2': 'TF',
          'alpha3': 'ATF',
          'numeric': 260
        },
        {
          'text': 'Gabon',
          'alpha2': 'GA',
          'alpha3': 'GAB',
          'numeric': 266
        },
        {
          'text': 'Gambia',
          'alpha2': 'GM',
          'alpha3': 'GMB',
          'numeric': 270
        },
        {
          'text': 'Georgia',
          'alpha2': 'GE',
          'alpha3': 'GEO',
          'numeric': 268
        },
        {
          'text': 'Germany',
          'alpha2': 'DE',
          'alpha3': 'DEU',
          'numeric': 276
        },
        {
          'text': 'Ghana',
          'alpha2': 'GH',
          'alpha3': 'GHA',
          'numeric': 288
        },
        {
          'text': 'Gibraltar',
          'alpha2': 'GI',
          'alpha3': 'GIB',
          'numeric': 292
        },
        {
          'text': 'Greece',
          'alpha2': 'GR',
          'alpha3': 'GRC',
          'numeric': 300
        },
        {
          'text': 'Greenland',
          'alpha2': 'GL',
          'alpha3': 'GRL',
          'numeric': 304
        },
        {
          'text': 'Grenada',
          'alpha2': 'GD',
          'alpha3': 'GRD',
          'numeric': 308
        },
        {
          'text': 'Guadeloupe',
          'alpha2': 'GP',
          'alpha3': 'GLP',
          'numeric': 312
        },
        {
          'text': 'Guam',
          'alpha2': 'GU',
          'alpha3': 'GUM',
          'numeric': 316
        },
        {
          'text': 'Guatemala',
          'alpha2': 'GT',
          'alpha3': 'GTM',
          'numeric': 320
        },
        {
          'text': 'Guernsey',
          'alpha2': 'GG',
          'alpha3': 'GGY',
          'numeric': 831
        },
        {
          'text': 'Guinea',
          'alpha2': 'GN',
          'alpha3': 'GIN',
          'numeric': 324
        },
        {
          'text': 'Guinea-Bissau',
          'alpha2': 'GW',
          'alpha3': 'GNB',
          'numeric': 624
        },
        {
          'text': 'Guyana',
          'alpha2': 'GY',
          'alpha3': 'GUY',
          'numeric': 328
        },
        {
          'text': 'Haiti',
          'alpha2': 'HT',
          'alpha3': 'HTI',
          'numeric': 332
        },
        {
          'text': 'Heard Island and McDonald Islands',
          'alpha2': 'HM',
          'alpha3': 'HMD',
          'numeric': 334
        },
        {
          'text': 'Holy See',
          'alpha2': 'VA',
          'alpha3': 'VAT',
          'numeric': 336
        },
        {
          'text': 'Honduras',
          'alpha2': 'HN',
          'alpha3': 'HND',
          'numeric': 340
        },
        {
          'text': 'Hong Kong',
          'alpha2': 'HK',
          'alpha3': 'HKG',
          'numeric': 344
        },
        {
          'text': 'Hungary',
          'alpha2': 'HU',
          'alpha3': 'HUN',
          'numeric': 348
        },
        {
          'text': 'Iceland',
          'alpha2': 'IS',
          'alpha3': 'ISL',
          'numeric': 352
        },
        {
          'text': 'India',
          'alpha2': 'IN',
          'alpha3': 'IND',
          'numeric': 356
        },
        {
          'text': 'Indonesia',
          'alpha2': 'ID',
          'alpha3': 'IDN',
          'numeric': 360
        },
        {
          'text': 'Iran (Islamic Republic of)',
          'alpha2': 'IR',
          'alpha3': 'IRN',
          'numeric': 364
        },
        {
          'text': 'Iraq',
          'alpha2': 'IQ',
          'alpha3': 'IRQ',
          'numeric': 368
        },
        {
          'text': 'Ireland',
          'alpha2': 'IE',
          'alpha3': 'IRL',
          'numeric': 372
        },
        {
          'text': 'Isle of Man',
          'alpha2': 'IM',
          'alpha3': 'IMN',
          'numeric': 833
        },
        {
          'text': 'Israel',
          'alpha2': 'IL',
          'alpha3': 'ISR',
          'numeric': 376
        },
        {
          'text': 'Italy',
          'alpha2': 'IT',
          'alpha3': 'ITA',
          'numeric': 380
        },
        {
          'text': 'Jamaica',
          'alpha2': 'JM',
          'alpha3': 'JAM',
          'numeric': 388
        },
        {
          'text': 'Japan',
          'alpha2': 'JP',
          'alpha3': 'JPN',
          'numeric': 392
        },
        {
          'text': 'Jersey',
          'alpha2': 'JE',
          'alpha3': 'JEY',
          'numeric': 832
        },
        {
          'text': 'Jordan',
          'alpha2': 'JO',
          'alpha3': 'JOR',
          'numeric': 400
        },
        {
          'text': 'Kazakhstan',
          'alpha2': 'KZ',
          'alpha3': 'KAZ',
          'numeric': 398
        },
        {
          'text': 'Kenya',
          'alpha2': 'KE',
          'alpha3': 'KEN',
          'numeric': 404
        },
        {
          'text': 'Kiribati',
          'alpha2': 'KI',
          'alpha3': 'KIR',
          'numeric': 296
        },
        {
          'text': 'Korea (the Democratic People\'s Republic of)',
          'alpha2': 'KP',
          'alpha3': 'PRK',
          'numeric': 408
        },
        {
          'text': 'Korea (the Republic of)',
          'alpha2': 'KR',
          'alpha3': 'KOR',
          'numeric': 410
        },
        {
          'text': 'Kuwait',
          'alpha2': 'KW',
          'alpha3': 'KWT',
          'numeric': 414
        },
        {
          'text': 'Kyrgyzstan',
          'alpha2': 'KG',
          'alpha3': 'KGZ',
          'numeric': 417
        },
        {
          'text': 'Lao People\'s Democratic Republic',
          'alpha2': 'LA',
          'alpha3': 'LAO',
          'numeric': 418
        },
        {
          'text': 'Latvia',
          'alpha2': 'LV',
          'alpha3': 'LVA',
          'numeric': 428
        },
        {
          'text': 'Lebanon',
          'alpha2': 'LB',
          'alpha3': 'LBN',
          'numeric': 422
        },
        {
          'text': 'Lesotho',
          'alpha2': 'LS',
          'alpha3': 'LSO',
          'numeric': 426
        },
        {
          'text': 'Liberia',
          'alpha2': 'LR',
          'alpha3': 'LBR',
          'numeric': 430
        },
        {
          'text': 'Libya',
          'alpha2': 'LY',
          'alpha3': 'LBY',
          'numeric': 434
        },
        {
          'text': 'Liechtenstein',
          'alpha2': 'LI',
          'alpha3': 'LIE',
          'numeric': 438
        },
        {
          'text': 'Lithuania',
          'alpha2': 'LT',
          'alpha3': 'LTU',
          'numeric': 440
        },
        {
          'text': 'Luxembourg',
          'alpha2': 'LU',
          'alpha3': 'LUX',
          'numeric': 442
        },
        {
          'text': 'Macao',
          'alpha2': 'MO',
          'alpha3': 'MAC',
          'numeric': 446
        },
        {
          'text': 'Madagascar',
          'alpha2': 'MG',
          'alpha3': 'MDG',
          'numeric': 450
        },
        {
          'text': 'Malawi',
          'alpha2': 'MW',
          'alpha3': 'MWI',
          'numeric': 454
        },
        {
          'text': 'Malaysia',
          'alpha2': 'MY',
          'alpha3': 'MYS',
          'numeric': 458
        },
        {
          'text': 'Maldives',
          'alpha2': 'MV',
          'alpha3': 'MDV',
          'numeric': 462
        },
        {
          'text': 'Mali',
          'alpha2': 'ML',
          'alpha3': 'MLI',
          'numeric': 466
        },
        {
          'text': 'Malta',
          'alpha2': 'MT',
          'alpha3': 'MLT',
          'numeric': 470
        },
        {
          'text': 'Marshall Islands',
          'alpha2': 'MH',
          'alpha3': 'MHL',
          'numeric': 584
        },
        {
          'text': 'Martinique',
          'alpha2': 'MQ',
          'alpha3': 'MTQ',
          'numeric': 474
        },
        {
          'text': 'Mauritania',
          'alpha2': 'MR',
          'alpha3': 'MRT',
          'numeric': 478
        },
        {
          'text': 'Mauritius',
          'alpha2': 'MU',
          'alpha3': 'MUS',
          'numeric': 480
        },
        {
          'text': 'Mayotte',
          'alpha2': 'YT',
          'alpha3': 'MYT',
          'numeric': 175
        },
        {
          'text': 'Mexico',
          'alpha2': 'MX',
          'alpha3': 'MEX',
          'numeric': 484
        },
        {
          'text': 'Micronesia (Federated States of)',
          'alpha2': 'FM',
          'alpha3': 'FSM',
          'numeric': 583
        },
        {
          'text': 'Moldova (the Republic of)',
          'alpha2': 'MD',
          'alpha3': 'MDA',
          'numeric': 498
        },
        {
          'text': 'Monaco',
          'alpha2': 'MC',
          'alpha3': 'MCO',
          'numeric': 492
        },
        {
          'text': 'Mongolia',
          'alpha2': 'MN',
          'alpha3': 'MNG',
          'numeric': 496
        },
        {
          'text': 'Montenegro',
          'alpha2': 'ME',
          'alpha3': 'MNE',
          'numeric': 499
        },
        {
          'text': 'Montserrat',
          'alpha2': 'MS',
          'alpha3': 'MSR',
          'numeric': 500
        },
        {
          'text': 'Morocco',
          'alpha2': 'MA',
          'alpha3': 'MAR',
          'numeric': 504
        },
        {
          'text': 'Mozambique',
          'alpha2': 'MZ',
          'alpha3': 'MOZ',
          'numeric': 508
        },
        {
          'text': 'Myanmar',
          'alpha2': 'MM',
          'alpha3': 'MMR',
          'numeric': 104
        },
        {
          'text': 'Namibia',
          'alpha2': 'NA',
          'alpha3': 'NAM',
          'numeric': 516
        },
        {
          'text': 'Nauru',
          'alpha2': 'NR',
          'alpha3': 'NRU',
          'numeric': 520
        },
        {
          'text': 'Nepal',
          'alpha2': 'NP',
          'alpha3': 'NPL',
          'numeric': 524
        },
        {
          'text': 'Netherlands',
          'alpha2': 'NL',
          'alpha3': 'NLD',
          'numeric': 528
        },
        {
          'text': 'New Caledonia',
          'alpha2': 'NC',
          'alpha3': 'NCL',
          'numeric': 540
        },
        {
          'text': 'New Zealand',
          'alpha2': 'NZ',
          'alpha3': 'NZL',
          'numeric': 554
        },
        {
          'text': 'Nicaragua',
          'alpha2': 'NI',
          'alpha3': 'NIC',
          'numeric': 558
        },
        {
          'text': 'Niger',
          'alpha2': 'NE',
          'alpha3': 'NER',
          'numeric': 562
        },
        {
          'text': 'Nigeria',
          'alpha2': 'NG',
          'alpha3': 'NGA',
          'numeric': 566
        },
        {
          'text': 'Niue',
          'alpha2': 'NU',
          'alpha3': 'NIU',
          'numeric': 570
        },
        {
          'text': 'Norfolk Island',
          'alpha2': 'NF',
          'alpha3': 'NFK',
          'numeric': 574
        },
        {
          'text': 'Northern Mariana Islands',
          'alpha2': 'MP',
          'alpha3': 'MNP',
          'numeric': 580
        },
        {
          'text': 'Norway',
          'alpha2': 'NO',
          'alpha3': 'NOR',
          'numeric': 578
        },
        {
          'text': 'Oman',
          'alpha2': 'OM',
          'alpha3': 'OMN',
          'numeric': 512
        },
        {
          'text': 'Pakistan',
          'alpha2': 'PK',
          'alpha3': 'PAK',
          'numeric': 586
        },
        {
          'text': 'Palau',
          'alpha2': 'PW',
          'alpha3': 'PLW',
          'numeric': 585
        },
        {
          'text': 'Palestine, State of',
          'alpha2': 'PS',
          'alpha3': 'PSE',
          'numeric': 275
        },
        {
          'text': 'Panama',
          'alpha2': 'PA',
          'alpha3': 'PAN',
          'numeric': 591
        },
        {
          'text': 'Papua New Guinea',
          'alpha2': 'PG',
          'alpha3': 'PNG',
          'numeric': 598
        },
        {
          'text': 'Paraguay',
          'alpha2': 'PY',
          'alpha3': 'PRY',
          'numeric': 600
        },
        {
          'text': 'Peru',
          'alpha2': 'PE',
          'alpha3': 'PER',
          'numeric': 604
        },
        {
          'text': 'Philippines',
          'alpha2': 'PH',
          'alpha3': 'PHL',
          'numeric': 608
        },
        {
          'text': 'Pitcairn',
          'alpha2': 'PN',
          'alpha3': 'PCN',
          'numeric': 612
        },
        {
          'text': 'Poland',
          'alpha2': 'PL',
          'alpha3': 'POL',
          'numeric': 616
        },
        {
          'text': 'Portugal',
          'alpha2': 'PT',
          'alpha3': 'PRT',
          'numeric': 620
        },
        {
          'text': 'Puerto Rico',
          'alpha2': 'PR',
          'alpha3': 'PRI',
          'numeric': 630
        },
        {
          'text': 'Qatar',
          'alpha2': 'QA',
          'alpha3': 'QAT',
          'numeric': 634
        },
        {
          'text': 'Republic of North Macedonia',
          'alpha2': 'MK',
          'alpha3': 'MKD',
          'numeric': 807
        },
        {
          'text': 'Romania',
          'alpha2': 'RO',
          'alpha3': 'ROU',
          'numeric': 642
        },
        {
          'text': 'Russian Federation',
          'alpha2': 'RU',
          'alpha3': 'RUS',
          'numeric': 643
        },
        {
          'text': 'Rwanda',
          'alpha2': 'RW',
          'alpha3': 'RWA',
          'numeric': 646
        },
        {
          'text': 'Réunion',
          'alpha2': 'RE',
          'alpha3': 'REU',
          'numeric': 638
        },
        {
          'text': 'Saint Barthélemy',
          'alpha2': 'BL',
          'alpha3': 'BLM',
          'numeric': 652
        },
        {
          'text': 'Saint Helena, Ascension and Tristan da Cunha',
          'alpha2': 'SH',
          'alpha3': 'SHN',
          'numeric': 654
        },
        {
          'text': 'Saint Kitts and Nevis',
          'alpha2': 'KN',
          'alpha3': 'KNA',
          'numeric': 659
        },
        {
          'text': 'Saint Lucia',
          'alpha2': 'LC',
          'alpha3': 'LCA',
          'numeric': 662
        },
        {
          'text': 'Saint Martin (French part)',
          'alpha2': 'MF',
          'alpha3': 'MAF',
          'numeric': 663
        },
        {
          'text': 'Saint Pierre and Miquelon',
          'alpha2': 'PM',
          'alpha3': 'SPM',
          'numeric': 666
        },
        {
          'text': 'Saint Vincent and the Grenadines',
          'alpha2': 'VC',
          'alpha3': 'VCT',
          'numeric': 670
        },
        {
          'text': 'Samoa',
          'alpha2': 'WS',
          'alpha3': 'WSM',
          'numeric': 882
        },
        {
          'text': 'San Marino',
          'alpha2': 'SM',
          'alpha3': 'SMR',
          'numeric': 674
        },
        {
          'text': 'Sao Tome and Principe',
          'alpha2': 'ST',
          'alpha3': 'STP',
          'numeric': 678
        },
        {
          'text': 'Saudi Arabia',
          'alpha2': 'SA',
          'alpha3': 'SAU',
          'numeric': 682
        },
        {
          'text': 'Senegal',
          'alpha2': 'SN',
          'alpha3': 'SEN',
          'numeric': 686
        },
        {
          'text': 'Serbia',
          'alpha2': 'RS',
          'alpha3': 'SRB',
          'numeric': 688
        },
        {
          'text': 'Seychelles',
          'alpha2': 'SC',
          'alpha3': 'SYC',
          'numeric': 690
        },
        {
          'text': 'Sierra Leone',
          'alpha2': 'SL',
          'alpha3': 'SLE',
          'numeric': 694
        },
        {
          'text': 'Singapore',
          'alpha2': 'SG',
          'alpha3': 'SGP',
          'numeric': 702
        },
        {
          'text': 'Sint Maarten (Dutch part)',
          'alpha2': 'SX',
          'alpha3': 'SXM',
          'numeric': 534
        },
        {
          'text': 'Slovakia',
          'alpha2': 'SK',
          'alpha3': 'SVK',
          'numeric': 703
        },
        {
          'text': 'Slovenia',
          'alpha2': 'SI',
          'alpha3': 'SVN',
          'numeric': 705
        },
        {
          'text': 'Solomon Islands',
          'alpha2': 'SB',
          'alpha3': 'SLB',
          'numeric': '090'
        },
        {
          'text': 'Somalia',
          'alpha2': 'SO',
          'alpha3': 'SOM',
          'numeric': 706
        },
        {
          'text': 'South Africa',
          'alpha2': 'ZA',
          'alpha3': 'ZAF',
          'numeric': 710
        },
        {
          'text': 'South Georgia and the South Sandwich Islands',
          'alpha2': 'GS',
          'alpha3': 'SGS',
          'numeric': 239
        },
        {
          'text': 'South Sudan',
          'alpha2': 'SS',
          'alpha3': 'SSD',
          'numeric': 728
        },
        {
          'text': 'Spain',
          'alpha2': 'ES',
          'alpha3': 'ESP',
          'numeric': 724
        },
        {
          'text': 'Sri Lanka',
          'alpha2': 'LK',
          'alpha3': 'LKA',
          'numeric': 144
        },
        {
          'text': 'Sudan',
          'alpha2': 'SD',
          'alpha3': 'SDN',
          'numeric': 729
        },
        {
          'text': 'Suriname',
          'alpha2': 'SR',
          'alpha3': 'SUR',
          'numeric': 740
        },
        {
          'text': 'Svalbard and Jan Mayen',
          'alpha2': 'SJ',
          'alpha3': 'SJM',
          'numeric': 744
        },
        {
          'text': 'Sweden',
          'alpha2': 'SE',
          'alpha3': 'SWE',
          'numeric': 752
        },
        {
          'text': 'Switzerland',
          'alpha2': 'CH',
          'alpha3': 'CHE',
          'numeric': 756
        },
        {
          'text': 'Syrian Arab Republic',
          'alpha2': 'SY',
          'alpha3': 'SYR',
          'numeric': 760
        },
        {
          'text': 'Taiwan (Province of China)',
          'alpha2': 'TW',
          'alpha3': 'TWN',
          'numeric': 158
        },
        {
          'text': 'Tajikistan',
          'alpha2': 'TJ',
          'alpha3': 'TJK',
          'numeric': 762
        },
        {
          'text': 'Tanzania, United Republic of',
          'alpha2': 'TZ',
          'alpha3': 'TZA',
          'numeric': 834
        },
        {
          'text': 'Thailand',
          'alpha2': 'TH',
          'alpha3': 'THA',
          'numeric': 764
        },
        {
          'text': 'Timor-Leste',
          'alpha2': 'TL',
          'alpha3': 'TLS',
          'numeric': 626
        },
        {
          'text': 'Togo',
          'alpha2': 'TG',
          'alpha3': 'TGO',
          'numeric': 768
        },
        {
          'text': 'Tokelau',
          'alpha2': 'TK',
          'alpha3': 'TKL',
          'numeric': 772
        },
        {
          'text': 'Tonga',
          'alpha2': 'TO',
          'alpha3': 'TON',
          'numeric': 776
        },
        {
          'text': 'Trinidad and Tobago',
          'alpha2': 'TT',
          'alpha3': 'TTO',
          'numeric': 780
        },
        {
          'text': 'Tunisia',
          'alpha2': 'TN',
          'alpha3': 'TUN',
          'numeric': 788
        },
        {
          'text': 'Turkey',
          'alpha2': 'TR',
          'alpha3': 'TUR',
          'numeric': 792
        },
        {
          'text': 'Turkmenistan',
          'alpha2': 'TM',
          'alpha3': 'TKM',
          'numeric': 795
        },
        {
          'text': 'Turks and Caicos Islands',
          'alpha2': 'TC',
          'alpha3': 'TCA',
          'numeric': 796
        },
        {
          'text': 'Tuvalu',
          'alpha2': 'TV',
          'alpha3': 'TUV',
          'numeric': 798
        },
        {
          'text': 'Uganda',
          'alpha2': 'UG',
          'alpha3': 'UGA',
          'numeric': 800
        },
        {
          'text': 'Ukraine',
          'alpha2': 'UA',
          'alpha3': 'UKR',
          'numeric': 804
        },
        {
          'text': 'United Arab Emirates',
          'alpha2': 'AE',
          'alpha3': 'ARE',
          'numeric': 784
        },
        {
          'text': 'United Kingdom of Great Britain and Northern Ireland',
          'alpha2': 'GB',
          'alpha3': 'GBR',
          'numeric': 826
        },
        {
          'text': 'United States Minor Outlying Islands',
          'alpha2': 'UM',
          'alpha3': 'UMI',
          'numeric': 581
        },
        {
          'text': 'United States of America',
          'alpha2': 'US',
          'alpha3': 'USA',
          'numeric': 840
        },
        {
          'text': 'Uruguay',
          'alpha2': 'UY',
          'alpha3': 'URY',
          'numeric': 858
        },
        {
          'text': 'Uzbekistan',
          'alpha2': 'UZ',
          'alpha3': 'UZB',
          'numeric': 860
        },
        {
          'text': 'Vanuatu',
          'alpha2': 'VU',
          'alpha3': 'VUT',
          'numeric': 548
        },
        {
          'text': 'Venezuela (Bolivarian Republic of)',
          'alpha2': 'VE',
          'alpha3': 'VEN',
          'numeric': 862
        },
        {
          'text': 'Viet Nam',
          'alpha2': 'VN',
          'alpha3': 'VNM',
          'numeric': 704
        },
        {
          'text': 'Virgin Islands (British)',
          'alpha2': 'VG',
          'alpha3': 'VGB',
          'numeric': '092'
        },
        {
          'text': 'Virgin Islands (U.S.)',
          'alpha2': 'VI',
          'alpha3': 'VIR',
          'numeric': 850
        },
        {
          'text': 'Wallis and Futuna',
          'alpha2': 'WF',
          'alpha3': 'WLF',
          'numeric': 876
        },
        {
          'text': 'Western Sahara',
          'alpha2': 'EH',
          'alpha3': 'ESH',
          'numeric': 732
        },
        {
          'text': 'Yemen',
          'alpha2': 'YE',
          'alpha3': 'YEM',
          'numeric': 887
        },
        {
          'text': 'Zambia',
          'alpha2': 'ZM',
          'alpha3': 'ZMB',
          'numeric': 894
        },
        {
          'text': 'Zimbabwe',
          'alpha2': 'ZW',
          'alpha3': 'ZWE',
          'numeric': 716
        },
        {
          'text': 'Åland Islands',
          'alpha2': 'AX',
          'alpha3': 'ALA',
          'numeric': 248
        }
      ]
    }
  },

  props: {
    value: String,
    disabled: Boolean,
    format: {
      type: String,
      default: 'alpha3'
    },
    icon: String,
    rules: Object
  },

  computed: {
    country: {
      get () {
        return this.value
      },
      set (country) {
        this.$emit('input', country)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/CountryDropdown.vue